import { combineReducers } from "redux";
import commonReducer from "./common";
import inviteReducer from "./invite";

const rootReducer = combineReducers({
  inviteDetails: inviteReducer,
  common: commonReducer
});

export default rootReducer;
